<template>
	<v-app>
      <AuthWrapper>
        <SideMenu v-if="user" :user="user" ref="sideMenu"></SideMenu>
        <Header v-if="user" v-on:sideMenuToggled="toggleSideMenu"></Header>
        <v-main>
              <v-container v-if="user || isAuthRoute" fluid>
                  <router-view></router-view>
              </v-container>
              <Login
                v-else
                @loggedIn="setUserContext"
              ></Login>
          </v-main>
          <v-footer padless>
              <v-col class="text-center" cols="12">
                  <strong>{{ new Date().getFullYear() }} - Taksikuutio Oy</strong>
              </v-col>
          </v-footer>
      </AuthWrapper>
	</v-app>
</template>

<script>
import SideMenu from "./components/SideMenu/SideMenu";
import Header from "./components/Header/Header";
import Login from "./views/Login";
import AuthWrapper from "./components/Auth/AuthWrapper";

export default {
    name: "App",
    components: {
        Header,
        SideMenu,
        Login,
        AuthWrapper
    },
    data: () => ({
        user: null
    }),
    computed: {
        isAuthRoute() {
            return this.$route.path.startsWith("/auth/") ||
               this.$route.name === "AuthCallback" ||
               this.$route.name === "Unauthorized";
        }
    },
    methods: {
        navigate(site) {
            this.$router.push({ name: site });
        },
        toggleSideMenu() {
            this.$refs.sideMenu.toggle();
        },
        async setUserContext() {
            try {
                // Get user from our modern auth service
                this.user = await this.$AuthService.getUser();

                if (this.user) {
                    this.$store.dispatch("user/setTenants", this.$AuthService.getTenants());
                    this.$store.dispatch("user/setOperators", this.$AuthService.getOperators());
                    this.$appInsights.setAuthenticatedUserContext(this.user.userId);
                }
            } catch (error) {
                // Error setting user context - suppressed for production
                this.user = null;
            }
        }
    }
};
</script>

<style>

.v-application {
   font-family: 'Inter', serif !important;
  }

div.v-input.theme--dark .v-input__slot {
	background-color: var(--v-primary-base) !important;
}
.even-item {
	background-color: #fafafa !important;
}

.odd-item {
	background-color: white !important;
}
</style>
